import { Box } from '@spark-web/box';
import { Container } from '@spark-web/container';
import { Spinner } from '@spark-web/spinner';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

type LoaderProps = {
  label?: string;
};

export function Loader({ label = 'Fetching details' }: LoaderProps) {
  return (
    <Container size="small">
      <Stack gap="xxlarge" padding="xxlarge">
        <Box flex={1} paddingY="xlarge" display="flex" alignItems="center" justifyContent="center">
          <Stack gap="large" padding="xxlarge" align="center">
            <Spinner data={{ testId: 'loading-indicator' }} size="xsmall" />
            {label && <Text>{label}</Text>}
          </Stack>
        </Box>
      </Stack>
    </Container>
  );
}
